export const CYesAndNo = {
  YES: {
    label: "Si",
    value: 1,
    id: 1
  },
  NO: {
    label: "No",
    value: 0,
    id: 0
  }
};

export const OYesAndNo = {
  [CYesAndNo.NO.value]: CYesAndNo.NO,
  [CYesAndNo.YES.value]: CYesAndNo.YES,
  [CYesAndNo.NO.label]: CYesAndNo.NO,
  [CYesAndNo.YES.label]: CYesAndNo.YES
};

export const AYesAndNo = [CYesAndNo.NO, CYesAndNo.YES];
